document.addEventListener("DOMContentLoaded", function () {
  const copyQuoteLink = document.querySelector(".copy-quote-link");

  copyQuoteLink?.addEventListener("click", function (event) {
    event.preventDefault();

    const originalText = this.textContent;

    navigator.clipboard.writeText(this.dataset.quoteLink);

    this.textContent = "Copied!";

    setTimeout(() => {
      this.textContent = originalText;
    }, 2000);
  });
});
